import { useEffect, useState } from "react";

export function DegradedModeBanner() {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const ce = e as CustomEvent<{ message?: string }>;
      setMessage(ce.detail?.message ?? "AI service temporarily degraded. Some models unavailable.");
    };
    window.addEventListener("studio:degradedMode", handler);
    return () => window.removeEventListener("studio:degradedMode", handler);
  }, []);

  if (!message) return null;

  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
        background: "#1a0f00", borderBottom: "1px solid #7c4a00",
        color: "#f0a040", padding: "8px 16px", fontSize: 12,
        display: "flex", justifyContent: "space-between", alignItems: "center",
        fontFamily: "Space Mono, monospace",
      }}
    >
      <span>⚠ {message}</span>
      <button
        onClick={() => setMessage(null)}
        style={{
          background: "none", border: "none", cursor: "pointer",
          color: "#f0a040", fontSize: 16, lineHeight: 1, padding: "0 4px",
        }}
      >
        ×
      </button>
    </div>
  );
}
